<template>
    <div class="content-wrapper" v-if="blogs">
        <div class="container">
            <h2 class="display-1 mb-3 pt-4">{{ $t('Travel Inspiration') }} <small>{{ $t('Stay.com Magazine') }}</small></h2>
            <b-row v-for="post in blogs.posts.slice(0,1)" :key="post.id" class="mb-4" align-v="center">
               <b-col md="8">
                  <a :href="post.url" target="_blank">
                     <b-img :src="post.feature_image.replace('images', 'images/size/w2000')" :title="post.title" fluid class="blog-img blog-img-large mb-3 mb-md-0" />
                  </a>
               </b-col>
               <b-col md="4">
                  <a :href="post.url" target="_blank">
                     <h3 class="display-3">{{ post.title }}</h3>
                  </a>
                  <template v-if="post.custom_excerpt">
                     <p>{{ post.custom_excerpt| truncate(150, '...') }}</p>
                  </template>
                  <template v-else-if="post.excerpt">
                     <p>{{ post.excerpt| truncate(150, '...') }}</p>
                  </template>
                  <ul class="list-unstyled meta">
                     <li>{{ convert(post) }}</li>
                     <li>{{ post.reading_time }} {{ $t('min read') }}</li>
                  </ul>
                  <b-button :href="post.url" target="_blank" variant="primary" size="md">
                     {{ $t('Read more') }} >
                  </b-button>
               </b-col>
            </b-row>
            <b-row>
               <b-col md="4" sm="6" class="mb-4" v-for="post in blogs.posts.slice(1,7)" :key="post.id">
                  <a :href="post.url" target="_blank">
                     <b-img :src="post.feature_image.replace('images', 'images/size/w600')" :title="post.title" fluid class="blog-img mb-3" />
                     <h3 class="display-3">{{ post.title }}</h3>
                  </a>
                  <template v-if="post.custom_excerpt">
                     <p>{{ post.custom_excerpt| truncate(150, '...') }}</p>
                  </template>
                  <template v-else-if="post.excerpt">
                     <p>{{ post.excerpt| truncate(150, '...') }}</p>
                  </template>
                  <ul class="list-unstyled meta">
                     <li>{{ convert(post) }}</li>
                     <li>{{ post.reading_time }} {{ $t('min read') }}</li>
                  </ul>
                  <b-button :href="post.url" target="_blank" variant="primary" size="sm">
                     {{ $t('Read more') }} >
                  </b-button>
               </b-col>
            </b-row>
            <hr/>
            <div class="text-center pt-2 pb-5">
               <b-button :href="moreLink" target="_blank" variant="outline-primary">
                  {{ $t('More at Stay.com Magazine') }}
               </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import dayjs from 'dayjs'
    var localizedFormat = require('dayjs/plugin/localizedFormat')
    dayjs.extend(localizedFormat)

    export default {
        name: 'Blogs',
        props: {
            tag: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                blogs: null,
                moreLink: 'https://magazine.stay.com.de',
            }
        },
        methods: {
            convert(post) {
                return dayjs(post.published_at).format('ll')
            },
            loadblogs() {
               let locale = this.$i18n.locale;
               locale = locale.match('([a-z][a-z])-[a-z][a-z]');

               let extra = '';

               if (this.tag) {
                  extra = '%2Btag:' + this.tag;
               }
               
               axios
                     .get('https://magazine.stay.com.de/ghost/api/v4/content/posts/?key=31cbb0945b82557b8e304d5d94&include=authors,tags&filter=tag:hash-' + locale[1] + extra)
                     .then(response => {
                        if (response.data) {
                            this.blogs = response.data;
                        }
                    })

            }
        },
        mounted () {
            this.loadblogs();
            
            if (this.tag) {
               this.moreLink = 'https://magazine.stay.com.de/tag/' + this.tag
            }
        },
    }
</script>

<style scoped>
    .blog-img{
        height: 200px;
        object-fit: cover;
        width:100%;
        border-radius:3px;
    }
    @media screen and (min-width:767px) {
        .blog-img-large{
            height: 400px;
        }
    }
   .meta li{
      display:inline-block;
      color:#777;
      font-size:0.8rem;
   }
   .meta li:after{
      content:'•';
      padding:0 5px;
   }
   .meta li:last-child:after{
      content:'';
   }
</style>
